import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchSubscriptions = (params) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("subscriptions", { params: { ...params } });
		return res.data;
	};
	return useQuery(["subscriptions", params], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchSubscriptions;
